import { createFileRoute } from "@tanstack/react-router"
import { OrderDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/orders/$orderUuid/"
)({
  component: () => (
    <AuthorizationGate resource={Resource.ORDER} action={Action.READ}>
      <OrderDetailPage />
    </AuthorizationGate>
  ),
})
